'use strict';

// 更新履歴ページの年ボタンクリックで該当年の見出しへスムーズスクロールする。
// Turbolinksのアンカー遷移（ページ再訪問による再描画）を避けるため preventDefault する。
$(document).on('click', '.js-changelog-year-link', function(e) {
  e.preventDefault();
  const id = this.getAttribute('href').slice(1);
  const heading = document.getElementById(id);
  if (heading) {
    heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#' + id);
  }
});
